// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading--2v6h6","loading_img":"loading_img--uq35Q"};